/**
* NGTDebugInstaller.js
* 
* Created 2021-06-11
*
* @author Henrique Campos
**/

import AbstractInstaller from "../../core/application/AbstractInstaller";
/////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////

export default class NGTDebugInstaller extends AbstractInstaller {

    /**
     * @param {infuse.Injector} injector 
     * @param {soma.Commands} commands 
     * @param {MediatorMapping} mediatorMap 
     */
    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);
/////////////////////
///////////////////////
/////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////
/////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////
//////////////////
    }
}